import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const clickUp = defineConnector({
  identifier: "clickUp",
  name: "ClickUp",
  tagLine: "Project management platform",
  logo,
  protocol: "http",
  tags: ["productivity"],
  defaultUrlPattern: () => "https://api\\.clickup\\.com/.*",
  auth: (app) =>
    headerAuth([{ name: "Authorization", value: app.oauthToken.accessToken }]),
  steps: [
    {
      title: "Create a ClickUp OAuth app",
      items: [
        {
          kind: "markdown",
          content:
            "Visit your [ClickUp integrations settings](https://app.clickup.com/settings/integrations) and click **'Build an app'** to create a new OAuth app.",
        },
      ],
    },
    {
      title: "Fill out the app details",
      items: [
        {
          kind: "markdown",
          content: "Copy and paste the following information into the form:",
        },
        {
          kind: "copyable",
          label: "App name",
          value: "3B",
        },
        {
          kind: "copyable",
          label: "Redirect URL",
          value: "{API_URL}/connected-apps/oauth/clickup/callback",
        },
      ],
    },
    {
      title: "Save your app",
      items: [
        {
          kind: "markdown",
          content:
            "Click **'Create app'** to save. You'll be shown your Client ID and Client Secret.",
        },
      ],
    },
    {
      title: "Input your client ID and secret",
      items: [
        {
          kind: "input",
          label: "Client ID",
          placeholder: "Paste your Client ID",
          required: true,
          target: { kind: "oauthConnection", field: "clientId" },
        },
        {
          kind: "input",
          label: "Client secret",
          placeholder: "Paste your Client secret",
          required: true,
          target: { kind: "oauthConnection", field: "clientSecret" },
        },
      ],
    },
    {
      title: "Authorize your ClickUp account",
      items: [
        {
          kind: "markdown",
          content:
            "Finally, authorize your ClickUp account so it can be used in 3B.",
        },
        {
          kind: "oauth",
          dependsOn: [
            { kind: "oauthConnection", field: "clientId" },
            { kind: "oauthConnection", field: "clientSecret" },
          ],
        },
      ],
    },
  ],
  oauth: {
    grantType: () => "authorization_code",
    authorizationEndpoint: () => "https://app.clickup.com/api",
    tokenEndpoint: () => "https://api.clickup.com/api/v2/oauth/token",
    tokenEndpointAuthMethod: () => "client_secret_post",
    clientCredentialsFrom: "db",
    scopes: () => [],
  },
  connectionTest: {
    protocol: "http",
    request: () => "https://api.clickup.com/api/v2/user",
  },
});
